import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
import Slider from 'react-slick'

// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Alert, Tooltip, Container, Typography, Grid } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import Image from '../../components/Image';
import yepimage1 from '../../assets/yepimages1.webp';
import yepimages2 from '../../assets/yepimages2.webp';
import yepimage3 from '../../assets/yepimage3.webp';

// sections
import { LoginForm } from '../../sections/auth/login';
// slider

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

const SectionContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(5),
  marginTop: theme.spacing(10),
  marginBottom: theme.spacing(5),
}));

const ImageWrapper = styled(Box)({
  width: '100%',
  height: 500, // consistent height for all images
  // overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
});

const StyledImage = styled('img')({
  width: '100%',
  height: '100%',
  borderRadius: 8,
  objectFit: 'contain',
});

const imageSources = [yepimage1, yepimages2, yepimage3];

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  // pauseOnHover: true,
  // adaptiveHeight: false,
};

// ----------------------------------------------------------------------

export default function Login() {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');

  // return (
  //   <Page title="Login">
  //     <RootStyle>
  //       <HeaderStyle>
  //         <Logo />
  //         {smUp && (
  //           <Typography variant="body2" sx={{ mt: { md: -2 } }}>
  //             Don’t have an account? {''}
  //             <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
  //               Get started
  //             </Link>
  //           </Typography>
  //         )}
  //       </HeaderStyle>

  //       {mdUp && (
  //         // <SectionStyle>
  //         //   <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
  //         //     Hi, Welcome In Yep
  //         //   </Typography>
  //         //   <Image
  //         //     visibleByDefault
  //         //     disabledEffect
  //         //     alt="login"
  //         //     src="https://minimals.cc/assets/illustrations/illustration_dashboard.png"
  //         //   />
  //         // </SectionStyle>
  //         <SectionContainer>
  //           <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }} gutterBottom>
  //             Hi, Welcome In Yep
  //           </Typography>
  //           <Slider {...sliderSettings}>
  //             {imageSources.map((src, idx) => (
  //               <Box key={idx} sx={{ px: 1 }}>
  //                 <ImageWrapper>
  //                 <StyledImage src={src} alt={`carousel-img-${idx}`} />
  //                 </ImageWrapper>
  //               </Box>
  //             ))}
  //           </Slider>
  //         </SectionContainer>
  //       )}

  //       <Container maxWidth="sm">
  //         <ContentStyle>
  //           <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
  //             <Box sx={{ flexGrow: 1 }}>
  //               <Typography variant="h4" gutterBottom>
  //                 Sign in to TPC
  //               </Typography>
  //               <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
  //             </Box>
  //           </Stack>

  //           <LoginForm />

  //           {!smUp && (
  //             <Typography variant="body2" align="center" sx={{ mt: 3 }}>
  //               Don’t have an account?{' '}
  //               <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
  //                 Get started
  //               </Link>
  //             </Typography>
  //           )}
  //         </ContentStyle>
  //       </Container>
  //     </RootStyle>
  //   </Page>
  // );

  return(
    <Page title="Login">
    <Grid container sx={{ minHeight: '100vh' }}>
      {/* LEFT: Image Slider */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#f4f6f8',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <SectionContainer>
          <Typography variant="h3" sx={{ px: 5, mt: 0, mb: 5 }} gutterBottom>
            Hi, Welcome In Yep
          </Typography>
          <Slider {...sliderSettings}>
            {imageSources.map((src, idx) => (
              <Box key={idx} sx={{ px: 1 }}>
                <ImageWrapper>
                  <StyledImage src={src} alt={`carousel-img-${idx}`} />
                </ImageWrapper>
              </Box>
            ))}
          </Slider>
        </SectionContainer>
      </Grid>

      {/* RIGHT: Login Form */}
      <Grid item xs={12} md={6} sx={{ position: 'relative' }}>
        <HeaderStyle>
          <Logo />
          {smUp && (
            <Typography variant="body2" sx={{ mt: { md: -2 } }}>
              Don’t have an account?{' '}
              <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                Get started
              </Link>
            </Typography>
          )}
        </HeaderStyle>

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Sign in to TPC
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
              </Box>
            </Stack>

            <LoginForm />

            {!smUp && (
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                Don’t have an account?{' '}
                <Link variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
                  Get started
                </Link>
              </Typography>
            )}
          </ContentStyle>
        </Container>
      </Grid>
    </Grid>
  </Page>
  );

}
